<template>
  <div >
    <modal @opened="opened" width="380" name="transaction-chat">
      <div class="card border transaction-chat text-left">
        <button @click="$modal.hide('transaction-chat')" class="btn-fixed">
          <span class="ti-close"></span>
        </button>
        <ul class="transaction-chat-messages">
          <li
            :class="`${
              message.user_id == $store.state.user.id
                ? 'transaction-chat-messages-me'
                : 'transaction-chat-messages-him'
            }`"
            v-for="(message, key) in renderMessages"
            :key="key"
          >
            <h5 v-if="message.user" class="mb-2">{{ message.user.name }}</h5>
            <div>
              <pre
                style="white-space: pre-wrap"
              ><code>{{ message.text }}</code></pre>
            </div>

            <small class="mt-2">
              {{ message.created_at | dateTimeFormat }}
            </small>
          </li>
        </ul>

        <div class="chat-control mt-2" ref="chatElement">
          <div>
            <textarea
              ref="inputElement"
              @keyup.enter="sendMessage"
              class="form-control"
              rows="2"
              v-model="data.text"
              placeholder="Сообщение / Xabar"
            ></textarea>

            <div class="chat-control-buttons mt-2 text-right">
              <button class="btn btn-icon btn-sm btn-info" @click="sendMessage">
                <span class="ti-email"></span>
                <span>{{ "push" | setText("Отправить") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <button
      @click="$modal.show('transaction-chat')"
      :class="`btn-chat ${newMessageClass ? 'btn-animation' : ''}`"
    >
      <span class="ti-email"></span>
    </button>
  </div>
</template>

<script>
import { errorNotify, toFormData } from "@/plugins/functions";

export default {
  data() {
    return {
      newMessageClass: false,
      data: {
        text: null,
      },
      messages: [],
    };
  },
  props: {
    value: {
      type: Array,
    },
    id: {
      default: null,
    },
    user_id: {
      default: null,
    },
    refresh: {
      default: function () {
        return;
      },
    },
  },
  beforeDestroy() {
    this.$socket.off(
      `retailbox_database_private-transaction-messages:${this.id}`
    );
  },
  mounted() {
    this.readMessage();
    try {
      this.$socket.on(
        `retailbox_database_private-transaction-messages:${this.id}`,
        (msg) => {
          try {
            this.messages.unshift(msg.message);
            this.scrollToBottom();

            if (!this.$refs.chatElement) {
              this.newMessageClass = true;
            }

            if (this.$store.state.user.id != msg.message.user_id) {
              this.$store.state.audio.play();

              this.$notify({
                title: msg.message.user.name,
                message: msg.message.text,
                icon: "ti-user",
                horizontalAlign: "left",
                verticalAlign: "bottom",
              });
            }
          } catch (error) {}
        }
      );

      this.scrollToBottom();
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    renderMessages: {
      get() {
        return Array.from(new Set(this.messages.map((obj) => obj.id)))
          .map((id) => this.messages.find((obj) => obj.id === id))
          .reverse();
      },
    },
  },
  methods: {
    opened() {
      this.newMessageClass = false;
      this.readMessage();
    },
    refreshWithTimeout() {
      this.refresh();
    },
    scrollToBottom() {
      setTimeout(() => {
        try {
          const targetElement = this.$refs.chatElement;
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          this.$refs.inputElement.focus();
        } catch (error) {}
      }, 10);
    },
    sendMessage() {
      this.$loading(true);
      return this.$http({
        method: "post",
        data: toFormData(this.data),
        url: `transactions/${this.id}/messages`,
      })
        .then((response) => {
          const data = response.data;
          this.data = {
            text: null,
          };
          this.messages.unshift(data.data);
          this.scrollToBottom();
          return data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    readMessage() {
      this.$loading(true);
      return this.$http({
        method: "get",
        url: `transactions/${this.id}/messages`,
      })
        .then((response) => {
          this.messages = response.data.data;
          this.scrollToBottom();
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>

<style lang="scss">
@keyframes opacityAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.btn-animation {
  animation: opacityAnimation 0.5s ease infinite;
}
.btn-fixed {
  text-align: center;
  padding: 0;
  z-index: 9;
  position: fixed;
  top: 10px;
  background-color: #fff;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 100%;
  border: none;
  box-shadow: none;
  font-size: 16px;
  color: #111;
}
.btn-chat {
  text-align: center;
  padding: 0;
  z-index: 9;
  position: fixed;
  bottom: 30px;
  right: 30px;
  color: #fff;
  background-color: #2c75ff;
  width: 70px;
  height: 70px;
  text-align: center;
  line-height: 70px;
  border-radius: 100%;
  border: none;
  box-shadow: none;
  font-size: 25px;
}
.transaction-chat {
  &-control {
    text-align: right;
    // -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    // -moz-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    // box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    padding: 15px 0 0 0;
    z-index: 9;
    // position: fixed;
    bottom: 0;
    right: 0;
    left: auto;
    background: #fff;
    width: 100%;
    & > div {
      width: auto;
    }
    &-buttons {
      margin-top: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: right;
    }
  }

  &-messages {
    &-me {
      margin-left: 10px;
      color: #999;
    }

    &-him {
      margin-right: 10px;
      color: #2c75ff;
    }
    & > li {
      display: block;
      background: #f2f2f2;
      margin-bottom: 10px;
      padding: 10px;
      border-radius: 10px;
      & h5 {
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 4px !important;
      }
      & pre {
        font-size: 12px;
      }
      & small {
        color: #999;
      }
    }
  }
}
</style>